<template>
    <div class="delete-lightbox-wrapper">
        <pui-lightbox
            :ref="REF_CONSTANTS.LIGHTBOX"
            default-header-label="Confirm Delete"
            default-footer-confirm-label="Delete"
            default-footer-cancel-label="Cancel"
            :default-footer-confirm-disabled="loading"
            :on-confirm-callback="triggerDelete"
            :close-on-e-s-c="false"
            fit-content
            @puilightbox:close="emitClose"
        >
            <div class="delete-lightbox-wrapper__content">
                {{ message }}
            </div>
        </pui-lightbox>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { PuiLightbox } from '~/models/libraries/pebble-ui';

const REF_CONSTANTS = {
    LIGHTBOX: 'delete-lightbox',
} as const;

@Component({})
export default class DeleteConfirmationComponent extends Vue {
    private readonly REF_CONSTANTS = REF_CONSTANTS;

    $refs!: {
        [REF_CONSTANTS.LIGHTBOX]: PuiLightbox;
    };

    @Prop()
    private lightboxOpen!: boolean;

    @Prop({ default: false })
    private loading: boolean;

    @Prop({ default: 'Are you sure you want to delete this item?' })
    private message!: string;

    @Watch('lightboxOpen')
    onLightboxOpenChanged(value: boolean): void {
        value ? this.open() : this.close();
    }

    private open(): void {
        this.$refs[REF_CONSTANTS.LIGHTBOX].open();
    }
    
    private close(): void {
        this.$refs[REF_CONSTANTS.LIGHTBOX].close();
    }

    private emitClose(): void {
        this.$emit('close-lightbox');
    }

    private triggerDelete(): void {
        this.$emit('trigger-delete');
    }
}
</script>

<style lang="scss" scoped>
  .delete-lightbox-wrapper {
    &__content {
      padding: 16px 0;
    }
  }
</style>
